import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useGetParentsByStatusQuery, useGetParentsByInquiryStatusQuery } from '@/services/parent-api';
import Page from '@/components/page';
import PageTitle from '@/components/page-title';
import QuickViewResults from './quick-view-results';
import {
  useGetAdoptionLiaisonsFamilyQuery,
  useGetCodeHomeStudyQuery,
  useGetCodeOpenInquiriesQuery,
} from '@/services/general-api';

const ParentQuickViewPage = () => {
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  const { data: liaisonData, isLoading: loadingLiaisonData } = useGetAdoptionLiaisonsFamilyQuery();
  const statusKey = queryParams.get('status');
  const liaisonId = parseInt(queryParams.get('liaison'));
  const inquiryStatusKey = queryParams.get('inquiry-status');
  const reportType = queryParams.get('reportType');
  const pageNumber = queryParams.get('page') || 1;
  const [breadcrumb, setBreadcrumb] = useState();
  const [title, setTitle] = useState('');
  const {
    data: data1,
    refetch: refetch1,
    isFetching: isFetching1,
  } = useGetParentsByStatusQuery({ statusKey, pageNumber, pageSize: 10, reportType, liaisonId }, { skip: !statusKey });
  const {
    data: data2,
    refetch: refetch2,
    isFetching: isFetching2,
  } = useGetParentsByInquiryStatusQuery(
    { inquiryStatusKey, pageNumber, pageSize: 10, reportType, liaisonId },
    { skip: !inquiryStatusKey },
  );
  const refetch = () => {
    if (statusKey) refetch1();
    else if (inquiryStatusKey) refetch2();
  };
  const { data: codeHomeStudy, isFetching: isFetching3 } = useGetCodeHomeStudyQuery(
    { statusKey },
    { skip: !statusKey },
  );
  const { data: codeOpenInquiries, isFetching: isFetching4 } = useGetCodeOpenInquiriesQuery(
    { inquiryStatusKey },
    { skip: !inquiryStatusKey },
  );
  const [results, setResults] = useState();

  useEffect(() => {
    let newTitle = '';
    let newBreadcrumb = [{ path: '/parent', label: 'Parents' }];

    if (codeHomeStudy) {
      newTitle = codeHomeStudy.name + ' Parents';
      newBreadcrumb.push({ path: '/parent/quick-view/home-study', label: 'Quick View' });
      newBreadcrumb.push(codeHomeStudy.name);
    } else if (codeOpenInquiries) {
      newTitle = codeOpenInquiries.name;
      newBreadcrumb.push({ path: '/parent/quick-view/open-inquiries', label: 'Open Inquiries' });
      newBreadcrumb.push(codeOpenInquiries.name);
    }

    if (liaisonData && liaisonId) {
      const liaison = liaisonData.find((item) => item.id === liaisonId);
      if (liaison) newTitle += ` for ${liaison.name}`;
    }

    setBreadcrumb(newBreadcrumb);
    setTitle(newTitle);
  }, [codeHomeStudy, codeOpenInquiries, liaisonId, liaisonData]);

  useEffect(() => {
    setResults(data1);
  }, [data1]);

  useEffect(() => {
    setResults(data2);
  }, [data2]);

  return (
    <Page breadcrumb={breadcrumb} size="xl">
      <PageTitle label="Parent Quick View" />
      <QuickViewResults
        status={statusKey}
        inquiryStatus={inquiryStatusKey}
        reportType={reportType}
        data={results}
        title={title}
        refetch={refetch}
        liaisonId={liaisonId}
        loading={isFetching1 || isFetching2 || isFetching3 || isFetching4 || loadingLiaisonData}
      />
    </Page>
  );
};

export default ParentQuickViewPage;
